﻿// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantDetail.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Tenant Detail component
 */
!(function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var observer = require('mobx-react').observer;
  var classnames = require('classnames');

  var Panel = require('share/components/controls/Izenda.Panel');

  var Validator = require('share/components/hoc/Izenda.Validator');
  var Input = Validator()(require('share/components/controls/Izenda.Input'));
  var constants = require('logic/data/Izenda.TenantConstants');
  var TenantDetailModules = require('./Izenda.TenantDetailModules');

  var TenantIDControl = observer(function (props){
    var showingTenant = props.showingTenant;
    var updateTenantId = props.updateTenantId;
    var localization = props.localization;

    return (
      <div className='form-group'>
        <label>{localization.getText('TENANT_DETAIL_TAB_TENANT_ID')} <span className="validation required" /></label>
        <Input className='form-control'
               type='text'
               maxLength='50'
               value={showingTenant.tenantID}
               onChange={updateTenantId}
               validations={constants.TENANT_ID_CONSTRAINT}
               field='tenantID'/>
      </div>
    )
  });

  var TenantNameControl = observer(function (props){
    var showingTenant = props.showingTenant;
    var updateTenantName = props.updateTenantName;
    var localization = props.localization;
    return (
      <div className='form-group'>
        <label>{localization.getText('COMMON_LABEL_TENANT_NAME')} <span className="validation required" /></label>
        <Input className='form-control'
               type='text'
               maxLength='50'
               value={showingTenant.name}
               onChange={updateTenantName}
               validations={constants.TENANT_NAME_CONSTRAINT}
               field='name'/>
      </div>
    )
  });

  var TenantDescriptionControl = observer(function (props){
    var showingTenant = props.showingTenant;
    var updateTenantDescription = props.updateTenantDescription;
    var localization = props.localization;
    return (
      <div className='form-group'>
        <label>{localization.getText('COMMON_LABEL_DESCRIPTION')}</label>
          <Input className='form-control'
                 type='text'
                 maxLength='100'
                 value={showingTenant.description}
                 onChange={updateTenantDescription} />
      </div>
    )
  });

  var TenantDetailTab = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    render: function () {
      var props = this.props;
      var store = props.store;
      var showingTenant = store.showingTenantCloned;
      var disabled = !showingTenant.active;

      return (
         <Panel className="u_marginLeft u_marginRight">
            <fieldset disabled={disabled}>
              <TenantIDControl localization={props.localization} showingTenant={showingTenant} updateTenantId={updateDetail(showingTenant, 'tenantID')} />
              <TenantNameControl localization={props.localization} showingTenant={showingTenant} updateTenantName={updateDetail(showingTenant, 'name')} />
              <TenantDescriptionControl localization={props.localization} showingTenant={showingTenant} updateTenantDescription={updateDetail(showingTenant, 'description')}/>
            </fieldset>

           {/* modules */}
           <div className="u_paddingTop">
            <TenantDetailModules store={store} />
           </div>
         </Panel>
      )
    },
  });

  function updateDetail(tenant, field){
    return function (e){
      tenant.setDataByKey(field, e.target.value);
    };
  }

  module.exports = connect()(TenantDetailTab);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/TenantManagement/Izenda.TenantDetailTab.jsx